import { Colors, Icon, Text } from "@blueprintjs/core";
import { Popover2 } from "@blueprintjs/popover2";
import { Box, Stack } from "ui-components";
import React from "react";
import styled from "styled-components";
import { match } from "ts-pattern";

import { TaskCellProps } from "./task-cell";

const TaskTypeCell = ({ task }: TaskCellProps) => {
  return (
    <Popover2
      interactionKind="hover"
      content={
        <Stack p="medium">
          {match(task.type)
            .with(undefined, () => null)
            .with("WEB_SCRAPE_CONFIG", () => (
              <Box flexDir="row" items="center">
                <ConfigIcon style={{ marginRight: 6 }} fastlane={false}>
                  <Icon icon={"wrench"} iconSize={12} />
                </ConfigIcon>

                {task.isFastlaneTask ? (
                  <Text>Fastlane - Web Scrape</Text>
                ) : (
                  <Text>Web Scrape</Text>
                )}
              </Box>
            ))
            .with("MANUAL", () => (
              <Box flexDir="row" items="center">
                <ConfigIcon fastlane={task.isFastlaneTask}>
                  <Icon icon={"add"} iconSize={12} />
                </ConfigIcon>
                {task.isFastlaneTask ? (
                  <Text>Fastlane - Manual Creation</Text>
                ) : (
                  <Text>Manual Creation</Text>
                )}
              </Box>
            ))
            .exhaustive()}
        </Stack>
      }
    >
      {match(task.type)
        .with(undefined, () => null)
        .with("WEB_SCRAPE_CONFIG", () => (
          <>
            <ConfigIcon fastlane={task.isFastlaneTask}>
              <Icon icon={"wrench"} iconSize={12} />
            </ConfigIcon>
          </>
        ))
        .with("MANUAL", () => (
          <>
            <ConfigIcon fastlane={task.isFastlaneTask}>
              <Icon icon={"add"} iconSize={12} />
            </ConfigIcon>
          </>
        ))
        .exhaustive()}
    </Popover2>
  );
};
export default TaskTypeCell;

export const ConfigIcon = styled.div<{ fastlane: boolean }>`
  background-color: ${(props) => {
    return props.fastlane && props.theme.darkMode
      ? Colors.GOLD1
      : props.fastlane
        ? Colors.GOLD5
        : props.theme.darkMode
          ? Colors.DARK_GRAY5
          : Colors.LIGHT_GRAY4;
  }};
  color: ${(props) => {
    return props.fastlane && props.theme.darkMode
      ? Colors.GOLD5
      : props.fastlane
        ? Colors.GOLD1
        : props.theme.darkMode
          ? Colors.LIGHT_GRAY3
          : Colors.DARK_GRAY5;
  }};
  border-radius: 50%;
  padding: 5px;
  margin-right: 5px;
  margin-left: 5px;
  display: flex;
  align-self: center;
`;
